import React from "react";

import SVGIcon from "../../../Images/SVGIcon";
import styles from "./style.module.css";

const Loader = () => {
  return (
    <div className={styles.container}>
      <div className={styles.innerContainer}>
        <SVGIcon className={styles.icon} src="components/v2/Sidebar/logo.svg" />
        <div className={styles.title}>Loading...</div>
      </div>
    </div>
  );
};

export default Loader;
